export default "__VITE_ASSET__qhhrJ1WG__"